export default "__VITE_ASSET__BZSR7vOV__"